import React from 'react';
import { FaDollarSign, FaRoute, FaStar, FaClock } from 'react-icons/fa';

const DriverStatsGrid = ({ totalEarnings = 0, totalKm = 0, totalHoursWorked = 0 }) => {
    return (
        <div className="dv-stats-grid mb-3">
            <div className="bry-stat-card">
                <div className="bry-stat-icon accent"><FaDollarSign size={18} /></div>
                <div>
                    <div className="bry-stat-value">${(Number(totalEarnings) || 0).toFixed(0)}</div>
                    <div className="bry-stat-label">Ganancias</div>
                </div>
            </div>
            <div className="bry-stat-card">
                <div className="bry-stat-icon success"><FaRoute size={18} /></div>
                <div>
                    <div className="bry-stat-value">{(Number(totalKm) || 0).toFixed(0)} km</div>
                    <div className="bry-stat-label">Recorridos</div>
                </div>
            </div>
            <div className="bry-stat-card">
                <div className="bry-stat-icon warning"><FaStar size={18} /></div>
                <div>
                    <div className="bry-stat-value">4.8</div>
                    <div className="bry-stat-label">Calificación</div>
                </div>
            </div>
            <div className="bry-stat-card">
                <div className="bry-stat-icon accent"><FaClock size={18} /></div>
                <div>
                    <div className="bry-stat-value">{(Number(totalHoursWorked) || 0).toFixed(1)}h</div>
                    <div className="bry-stat-label">Tiempo activo</div>
                </div>
            </div>
        </div>
    );
};

export default DriverStatsGrid;
